<template>
  <div>
    <VerifyTyc />
    <div v-if="this.$store.state.tyc == 1"><verifyPromo /></div>
    <v-overlay :value="overlay" style="height: 100vh">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <MisCuentas />
    <iframe
      :src="gameUrl"
      :key="iframeUpdate"
      :style="
        size < 960
          ? 'width: 100%; height: calc(' + this.screenHeight * 0.91 + 'px)'
          : 'width: 100%; height: 91vh'
      "
      frameborder="0"
    ></iframe>
    
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import MisCuentas from "../components/MisCuentas.vue";
import misCuentas from "../components/MisCuentas.vue";
export default {
  data() {
    return {
      gameUrl: null,
      overlay: true,
      isMobile: 0,
      misCuentas,
      iframeUpdate: false,
      multiplicador: 1,
      mon: null,
      screenHeight: 0,
    };
  },
  watch: {
    idmoneda() {
      this.overlay = true;
      this.getGame();
      //this.iframeUpdate = !this.iframeUpdate;
      //this.showChat();
    },
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  mounted() {
    this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth < 600 ? 1 : 0;
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    axios({
      method: "post",
      url: `details`,
    }).then((response) => {
      this.$store.state.nombre = response.data.success.name;
    });
    this.getSaldo();
    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
    this.idpos = sessionStorage.getItem("idpos");
    this.getGame();
  },
  updated() {
    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
  },
  methods: {
    ...mapActions(["getSaldo"]),
    onResize() {
      this.isMobile = window.innerWidth < 600 ? 1 : 0;
    },
    getGame() {
      this.mon = "";
      this.multiplicador = 1;
      if (this.$store.state.idmoneda == 1) {
        this.mon = "VES";
        this.multiplicador = 105;
      } else if (this.$store.state.idmoneda == 2) this.mon = "USD";
      else if (this.$store.state.idmoneda == 3) this.mon = "PEN";
      else if (this.$store.state.idmoneda == 7) this.mon = "COP";
      else if (this.$store.state.idmoneda == 8) this.mon = "CLP";
      axios({
        method: "post",
        url: `https://apitr.xyz/onlineapi/api/loginpuestos`,
        data: {
          moneda: this.mon,
        },
      }).then((response) => {
        console.log(response);
        const url = response.data.url;
        this.gameUrl = url;
        //alert("Las unidades de su Cartera seran convertidas en Bolivares para realizar las Jugadas");
        this.iframeUpdate = !this.iframeUpdate;
        this.overlay = false;
      });
    },
  },
  computed: {
    size() {
      return this.$store.state.windowSize.x;
    },
    moneda() {
      return this.$store.state.moneda;
    },
    idmoneda() {
      return this.$store.state.idmoneda;
    },
    idsb() {
      return this.$store.state.idsb;
    },
    currentBalance() {
      return this.$store.state.currentBalance;
    },
    dialogProgramas: {
      get() {
        return this.$store.state.dialogProgramas;
      },
      set(value) {
        this.$store.state.dialogProgramas = value;
      },
    },
    idpos: {
      get() {
        return this.$store.state.idpos;
      },
      set(e) {
        this.$store.state.idpos = e;
      },
    },
  },
  components: { MisCuentas },
};
</script>

<style>
header {
  background-color: #fa22229a;
  border-radius: 5px;
  color: #fff;
  padding: 1px;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 3px;
}

nav ul {
  list-style: none;
  padding: 3px;
  margin: 0;
}

nav li {
  display: inline; /* Hace que los ítems del menú estén en una línea horizontal */
  margin-right: 20px; /* Espacio entre los ítems del menú */
}

nav a {
  text-decoration: none;
  color: #fff !important;
  font-size: 16px;
}

nav a:hover {
  font-size: 17px;
  color: #000 !important;
}
</style>
